import { Table, TableProps } from 'antd';
import styled from 'styled-components';

type Props = {
  data: any[];
  columns: any[];
} & TableProps<any>;

const BasicTable = ({ data, columns, ...props }: Props) => (
  <StyledTable
    {...props}
    columns={columns}
    pagination={false}
    dataSource={data}
  />
);

const StyledTable: React.FC<TableProps<any>> = styled(Table)`
  tr th {
    padding: 24px;
  }
  tr td {
    border-radius: 2px 0px 0px 0px;
    padding: 0 10px !important;
  }
  tr:nth-child(odd) td {
    background: rgba(70, 106, 251, 0.03);
  }
`;

export default BasicTable;
